import React from 'react';
import classes from './SmoPage.module.css';

import {Typography, Box} from '@mui/material';
import {BasicContainer, ContainerFull} from '../../UI/ContentContainer';

import { SmoPageImage } from './SmoPageImage';
import TextContent from '../../UI/TextContent';
import PageTitle from '../../UI/PageTitle';
import SmoFoldList from './SmoFoldList';

import SupportContent from '../../UI/SupportContent';
import building from '../../../assets/img/building_2.png';
import document from '../../../assets/img/document_consignment.png';
import Raw from '../../UI/Text/Raw';
import MetaTags from '../../MetaTags/MetaTags';

// image


const TABLE_DATA = [
    {
        id: 1,
        title: '법 제17조제1항을 위반하여 안전관리자를 두지 않거나 업무를 수행하도록 하지 않은 경우',
        subtitle: '제재사항',
        tableHead: ['근거법조문', '세부내용', '1차', '2차', '3차'],
        data: [
            [
                '법 제175조제5항제1호',
                '안전관리자를 선임하지 않은 경우',
                '500','500','500'],
        ]
    },
    {
        id: 2,
        title: '법 제17조제3항에 따른 명령을 위반하여 안전관리자를 늘리지 않거나 교체하지 않은 경우',
        subtitle: '제재사항',
        tableHead: ['근거법조문', '세부내용', '1차', '2차', '3차'],
        data: [
            ['법 제175조제5항제2호','-','500','500','500'],
        ]
    }

]

const supportData = [
    '월 2회 이상 사업장 안전관리상태 점검 및 법령 위반사항, 불안전한 요소에 대한 구체적인 개선대책 제시',
    '신규계약, 중대재해발생 및 동종업종평균재해율 이상인 사업장에 대한 정밀안전점검 실시',
    '산업재해발생의 원인조사 및 재발방지를 위한 기술적 조언·지도',
    '최신 계측장비를 활용한 점검 및 개선대책 제시',
    '안전기술자료 및 교육자료 등 각종 안전관련 자료제공',
    '산업안전보건법, 산업재해보상보험법 및 근로기준법 등 관련 법률 상담',
    '기타 안전보건개선계획서 작성 등 각종 안전관련 업무지원'
];


export const SmoImageCard = props => {

    return (
        <Box className={props.className || ''} {...props.sx}>
            {props.image}
            <Box sx={{display:"flex", flexDirection: "column", alignItems: "center", paddingTop: "10px", flex: 0}}>
                <div>
                    <Typography variant="subtitle2" component="span">{props.title}</Typography>
                </div>
                <div>
                    <Typography variant="body2" component="span">{props.description}</Typography>
                </div>
            </Box>
        </Box>
    )
}

const SmoPage = () => {
    return (
        <BasicContainer>
            <MetaTags
                title="안전관리업무위탁"
                description="안전관리업무위탁에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-안전관리업무위탁"
                ogdescription="안전관리업무위탁에 대해 소개 합니다."
            />
            <PageTitle title="안전관리업무위탁"/>

            <TextContent
                title="안전관리업무위탁이란?"
            >
                <Typography variant="description" component="p" sx={{marginBottom: "10px"}}>
                    상시 근로자수 50명 이상을 사용하는 사업장의 경우 안전관리자를 선임하여 안전에 관한 기술적인 사항에 대해 사업주 또는 관리책임자를 보좌하고 관리감독자에게 조언.지도하도록 하고 있으며, 이 경우 안전관리자의 업무를 안전관리전문기관에 위탁(건설업 제외) 가능함.
                </Typography>
                <Raw description="[산업안전보건법 제17조]" />
            </TextContent>


            <ContainerFull style={{display:"flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                <Box component="section" data-aos="fade-up">
                    <Typography variant="subTitle" component="h5" sx={{textAlign:"center", marginBottom: "20px"}}>안전관리업무 위탁대상</Typography>
                    <Box className={classes.contentImageArea}>
                        <SmoImageCard 
                            className={classes.contentImage}
                            image={<SmoPageImage alt="building" image={building}/>}
                            title="상시근로자 50명 이상 사업장"
                            description="(안전관리자 법적 선임의무가 있는 사업장)"
                            
                        />
                        <SmoImageCard 
                            className={classes.contentImage}
                            // sx={{width: "270px", padding: "10px", textAlign:"center"}}
                            image={<SmoPageImage alt="document" image={document}/>}
                            title="안전관리업무를 위탁하고자 하는 사업장"
                            description="(산업안전보건법 시행령 별표3)"
                            
                        />
                    </Box>
                </Box>
            </ContainerFull>


            <TextContent title="법적제재사항" data-aos="fade-up">
                <Typography variant="h6">위반행위</Typography>
                <div style={{display: "flex", flexDirection:"column", gap: "10px"}}>
                {
                    TABLE_DATA.map(data => (
                        <SmoFoldList 
                            key={data.id}
                            title={data.title}
                            subtitle={data.subtitle}
                            thead={data.tableHead}
                            data={data.data}
                        />
                    ))
                }

                </div>
            </TextContent>
        
            <SupportContent 
                title="위탁업무 세부내용"
                data={supportData}
                aos="fade-left"
            />
            
        </BasicContainer>
    )
}

export default SmoPage;